export * from './src/ecom-v1-wishlist-wishlists.universal.js';
